import * as React from "react";

interface Props {
  onLogin: () => void;
}

const LoginPage = ({ onLogin }: Props) => {
  const [hovered, setHovered] = React.useState(false);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
        background: "#F4F6F9",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <div
        style={{
          background: "#FFFFFF",
          borderRadius: "16px",
          padding: "48px 40px",
          boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
          maxWidth: "420px",
          width: "100%",
          textAlign: "center",
        }}
      >
        {/* Lock icon */}
        <div
          style={{
            width: "64px",
            height: "64px",
            background: "#3B82F6",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>

        {/* Title */}
        <h1
          style={{
            margin: 0,
            fontSize: "24px",
            fontWeight: 700,
            color: "#111827",
            letterSpacing: "-0.3px",
          }}
        >
          Qtrust IGA
        </h1>

        {/* Subtitle */}
        <p
          style={{
            margin: 0,
            fontSize: "14px",
            color: "#5A6578",
            lineHeight: "1.6",
          }}
        >
          Sign in with your CloudEQ account to continue.
        </p>

        {/* SSO Button */}
        <button
          onClick={onLogin}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          style={{
            width: "100%",
            padding: "13px 24px",
            background: hovered ? "#2563EB" : "#3B82F6",
            color: "#FFFFFF",
            border: "none",
            borderRadius: "8px",
            fontSize: "15px",
            fontWeight: 600,
            cursor: "pointer",
            transition: "background 0.15s",
            letterSpacing: "0.1px",
          }}
        >
          Sign in with CloudEQ SSO
        </button>

        {/* Disclaimer */}
        <p
          style={{
            margin: 0,
            fontSize: "12px",
            color: "#9CA3AF",
            lineHeight: "1.6",
          }}
        >
          You will be redirected to the CloudEQ identity provider.
          Your credentials are never handled by Qtrust.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
